import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
import { html } from '@microsoft/fast-element';
export const templateDataTableHeaderV2 = html `<template role="rowgroup"><slot></slot></template>`;
export class DataTableHeaderV2Component extends ChameleonElementMixin(FoundationElement) {
}
